"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSelect = require("react-select");
var _reactTinyVirtualList = _interopRequireDefault(require("react-tiny-virtual-list"));
var _lodash = require("lodash");
var _excluded = ["children", "options", "virtualizeOptions"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var CustomMenuList = function CustomMenuList(_ref) {
  var children = _ref.children,
    options = _ref.options,
    virtualizeOptions = _ref.virtualizeOptions,
    props = _objectWithoutProperties(_ref, _excluded);
  var optionallyVirtualizedMenuGroups = (0, _react.useMemo)(function () {
    if (!(0, _lodash.isArray)(children) || !virtualizeOptions) {
      return children;
    }
    var virtualizeOptionsList = [];
    var groupHeadingIndexes = [];
    children.forEach(function (optionsGroup, key) {
      // Saving group heading list index to transform those blocks later on
      groupHeadingIndexes.push(virtualizeOptionsList.length);
      // Pushing the custom GroupHeading as the first element and other children options following
      virtualizeOptionsList.push( /*#__PURE__*/_react.default.createElement("div", {
        className: "select-payer__group-heading",
        id: "react-select-3-group-".concat(key, "-heading")
      }, optionsGroup.props.label));
      var groupChildren = optionsGroup.props.children;
      groupChildren.forEach(function (option) {
        return virtualizeOptionsList.push(option);
      });
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "select-payer__group"
    }, /*#__PURE__*/_react.default.createElement(_reactTinyVirtualList.default, {
      width: "100%",
      height: 1000,
      itemCount: virtualizeOptionsList.length,
      itemSize: function itemSize(index) {
        return (0, _lodash.includes)(groupHeadingIndexes, index) ? 72 : 40;
      },
      overscanCount: 10
      // Passing the style to the wrapper is compulsory here for the list to be working
      ,
      renderItem: function renderItem(_ref2) {
        var index = _ref2.index,
          style = _ref2.style;
        return /*#__PURE__*/_react.default.createElement("div", {
          key: index,
          style: style
        }, virtualizeOptionsList[index]);
      }
    }));
  }, [children, options, virtualizeOptions]);
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.MenuList, props, optionallyVirtualizedMenuGroups);
};
var _default = CustomMenuList;
exports.default = _default;